module.exports = __webpack_public_path__ + "img/神鸟详情.3564af29.jpg";